import React, {useEffect, useState} from 'react';
import {searchPromptsWithSearchCriteria} from "../../services/prompt-data-service";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PROMPT_FIELDS_LIST, PROMPT_INPUT_FIELDS} from "../../constants/prompt.constant";
import AddEditPrompt from "./add-edit-prompt";
import RenderFields from "../../../common/ui/render-fields";
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const defaultFilterCriteria: any = {}
const emptyFilterCriteria: any = {}

const PromptsList = () => {
    const [promptsList, setPromptsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [selectedPrompt, setSelectedPrompt] = useState(null);

    const getPromptList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const promptListResult = await searchPromptsWithSearchCriteria(searchCriteriaList);
        // console.log('promptListResult', promptListResult)

        setPromptsList(promptListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPromptList();
    }, [filterCriteria]);

    const refreshPromptList = async () => {
        await getPromptList();
    }

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};
        const {type, name, value} = event.target;

        if (type === 'checkbox') {
            existingFilterCriteria[name] = !existingFilterCriteria[name];
        } else {
            existingFilterCriteria[name] = value;
        }

        setFilterCriteria(existingFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start -mt-2 -ml-2 mb-2 w-full">
                    <div className="flex flex-wrap justify-start w-3/4">
                        <RenderFields
                            parentForm={filterCriteria}
                            handleDetailChanges={handleFilterChanges}
                            fieldList={_.groupBy(PROMPT_INPUT_FIELDS, 'group')['filter']}
                            enableEdit={true}
                            fieldClassName={'w-1/3'}/>
                    </div>

                    <div className="">
                        <button
                            onClick={() => clearFilterCriteria()}
                            className="button-small-link mt-9">
                            Clear Filters
                        </button>
                    </div>

                    <div className="ml-4 mt-9">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-full flex items-center justify-end">
                    <div className="ml-2">
                        <AddEditPrompt
                            isAddPrompt={true}
                            refreshPromptList={refreshPromptList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="shopify-table-container w-full overflow-y-scroll border-y border-gray-400 bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={promptsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Prompts'}/>

                    {promptsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {PROMPT_FIELDS_LIST?.map((promptField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white text-left pl-2 ${promptField?.cssClass}`}>{promptField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {promptsList?.map((prompt, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PROMPT_FIELDS_LIST?.map((promptField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${promptField?.cssClass}`}>
                                                {prompt[promptField?.attribute]}
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 w-auto">
                                        <div className="flex justify-center">
                                            <AddEditPrompt
                                                isEditPrompt={true}
                                                selectedPrompt={prompt}
                                                refreshPromptList={refreshPromptList}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PromptsList
